(function(SK){
var A = SK.astro; var D = SK.data;
var norm360 = A.norm360, geoLon = A.geoLon, rahuLon = A.rahuLon, lahiri = A.lahiri, sidereal = A.sidereal, ascendantTrop = A.ascendantTrop, isRetrograde = A.isRetrograde, julianDay = A.julianDay;
var RASHIS = D.RASHIS, NAKSHATRAS = D.NAKSHATRAS, PLANETS = D.PLANETS, DASHA_YEARS = D.DASHA_YEARS, DASHA_ORDER = D.DASHA_ORDER, TRAITS = D.TRAITS, RECS = D.RECS, dailyHoro = D.dailyHoro;

var TITHI_NAMES = ["Pratipada","Dwitiya","Tritiya","Chaturthi","Panchami","Shashthi","Saptami","Ashtami","Navami","Dashami","Ekadashi","Dwadashi","Trayodashi","Chaturdashi","Purnima"];
var KARANA_MOVEABLE = ["Bava","Balava","Kaulava","Taitila","Garaja","Vanija","Vishti"];
var KARANA_FIXED_END = ["Shakuni","Chatushpada","Naga"];
var YOGA_NAMES = ["Vishkambha","Preeti","Ayushman","Saubhagya","Shobhana","Atiganda","Sukarma","Dhriti","Shoola","Ganda","Vriddhi","Dhruva","Vyaghata","Harshana","Vajra","Siddhi","Vyatipata","Variyana","Parigha","Shiva","Siddha","Sadhya","Shubha","Shukla","Brahma","Indra","Vaidhriti"];
var VARA_NAMES = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];

var YONIS = ["Horse","Elephant","Sheep","Serpent","Serpent","Dog","Cat","Sheep","Cat","Rat","Rat","Cow","Buffalo","Tiger","Buffalo","Tiger","Deer","Deer","Dog","Monkey","Mongoose","Monkey","Lion","Horse","Lion","Cow","Elephant"];
var GANS = ["Deva","Manushya","Rakshasa","Manushya","Deva","Manushya","Deva","Deva","Rakshasa","Rakshasa","Manushya","Manushya","Deva","Rakshasa","Deva","Rakshasa","Deva","Rakshasa","Rakshasa","Manushya","Manushya","Deva","Rakshasa","Rakshasa","Manushya","Manushya","Deva"];
var NADIS = ["Adi","Madhya","Antya","Antya","Madhya","Adi","Adi","Madhya","Antya","Antya","Madhya","Adi","Adi","Madhya","Antya","Antya","Madhya","Adi","Adi","Madhya","Antya","Antya","Madhya","Adi","Adi","Madhya","Antya"];
var NAK_ALPHABETS = [
["Chu","Che","Cho","La"],["Li","Lu","Le","Lo"],["A","I","U","E"],
["O","Va","Vi","Vu"],["Ve","Vo","Ka","Ki"],["Ku","Gha","Nga","Chha"],
["Ke","Ko","Ha","Hi"],["Hu","He","Ho","Da"],["Di","Du","De","Do"],
["Ma","Mi","Mu","Me"],["Mo","Ta","Ti","Tu"],["Te","To","Pa","Pi"],
["Pu","Sha","Na","Tha"],["Pe","Po","Ra","Ri"],["Ru","Re","Ro","Ta"],
["Ti","Tu","Te","To"],["Na","Ni","Nu","Ne"],["No","Ya","Yi","Yu"],
["Ye","Yo","Bha","Bhi"],["Bhu","Dha","Pha","Dha"],["Bhe","Bho","Ja","Ji"],
["Khi","Khu","Khe","Kho"],["Ga","Gi","Gu","Ge"],["Go","Sa","Si","Su"],
["Se","So","Da","Di"],["Du","Tha","Jha","Na"],["De","Do","Cha","Chi"]
];
var VARNA = { karka:"Brahmin", vrishchika:"Brahmin", meena:"Brahmin", mesha:"Kshatriya", simha:"Kshatriya", dhanu:"Kshatriya", vrishabha:"Vaishya", kanya:"Vaishya", makara:"Vaishya", mithuna:"Shudra", tula:"Shudra", kumbha:"Shudra" };
var VASHYA = { mesha:"Chatushpada", vrishabha:"Chatushpada", mithuna:"Manav", karka:"Jalachar", simha:"Vanachar", kanya:"Manav", tula:"Manav", vrishchika:"Keet", dhanu:"Manav", makara:"Chatushpada", kumbha:"Manav", meena:"Jalachar" };
var TATVA_BY_RASHI = { mesha:"Fire", simha:"Fire", dhanu:"Fire", vrishabha:"Earth", kanya:"Earth", makara:"Earth", mithuna:"Air", tula:"Air", kumbha:"Air", karka:"Water", vrishchika:"Water", meena:"Water" };
var PAYA_BY_RASHI = { mesha:"Silver", vrishabha:"Silver", mithuna:"Gold", karka:"Gold", simha:"Copper", kanya:"Copper", tula:"Iron", vrishchika:"Iron", dhanu:"Silver", makara:"Silver", kumbha:"Gold", meena:"Gold" };

function panchang(sunLon, moonLon) {
var elong = norm360(moonLon - sunLon);
var tithiIdx = Math.floor(elong / 12);
var paksha = tithiIdx < 15 ? "Shukla" : "Krishna";
var pIdx = tithiIdx < 15 ? tithiIdx : tithiIdx - 15;
var tithi;
if (paksha === "Krishna" && pIdx === 14) tithi = "Amavasya";
else if (paksha === "Shukla" && pIdx === 14) tithi = "Purnima";
else tithi = paksha + " " + TITHI_NAMES[pIdx];

var karanaIdx = Math.floor(elong / 6);
var karana;
if (karanaIdx === 0) karana = "Kimstughna";
else if (karanaIdx >= 57) karana = KARANA_FIXED_END[karanaIdx - 57];
else karana = KARANA_MOVEABLE[(karanaIdx - 1) % 7];

var yogaSum = norm360(sunLon + moonLon);
var yoga = YOGA_NAMES[Math.floor(yogaSum / (360/27))];

return { tithi: tithi, paksha: paksha, karana: karana, yoga: yoga };
}

function sunriseSunset(year, month, day, lat, lon, tzMin) {
var D2R = Math.PI / 180;
// NOAA: n = integer day count from J2000 (Jan 1 2000 12:00 UT). Use noon-UT JD.
var jd0 = julianDay(year, month, day, 12, 0);
var n = jd0 - 2451545.0 + 0.0008;
var Jstar = n - lon/360.0;
var M = norm360(357.5291 + 0.98560028 * Jstar);
var C = 1.9148 * Math.sin(M * D2R) + 0.02 * Math.sin(2*M*D2R) + 0.0003 * Math.sin(3*M*D2R);
var lambda = norm360(M + C + 180 + 102.9372);
var Jtransit = 2451545.0 + Jstar + 0.0053 * Math.sin(M*D2R) - 0.0069 * Math.sin(2*lambda*D2R);
var delta = Math.asin(Math.sin(lambda*D2R) * Math.sin(23.44*D2R));
var cosArg = (Math.sin(-0.833*D2R) - Math.sin(lat*D2R) * Math.sin(delta)) / (Math.cos(lat*D2R) * Math.cos(delta));
if (cosArg < -1 || cosArg > 1) return { rise: "--:--:--", set: "--:--:--" };
var ha = Math.acos(cosArg) / D2R;
var Jrise = Jtransit - ha/360;
var Jset = Jtransit + ha/360;
function fmt(J) {
var fracDay = J + 0.5 - Math.floor(J + 0.5);
var totalMinsUT = fracDay * 1440;
var totalMinsLocal = ((totalMinsUT + tzMin) % 1440 + 1440) % 1440;
var h = Math.floor(totalMinsLocal / 60);
var m = Math.floor(totalMinsLocal % 60);
var s = Math.floor((totalMinsLocal - Math.floor(totalMinsLocal)) * 60);
return (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
}
return { rise: fmt(Jrise), set: fmt(Jset) };
}

function antardashasFor(lord, startISO, years) {
var out = [];
var startIdx = DASHA_ORDER.indexOf(lord);
var cursor = new Date(startISO);
for (var i = 0; i < 9; i++) {
var ld = DASHA_ORDER[(startIdx + i) % DASHA_ORDER.length];
var yy = years * DASHA_YEARS[ld] / 120;
var end = new Date(cursor.getTime() + yy * 365.25 * 24 * 3600 * 1000);
out.push({ lord: ld, from: cursor.toISOString(), to: end.toISOString(), years: +yy.toFixed(3) });
cursor = end;
}
return out;
}

function computeKundli(inp) {
var dp = inp.date.split("-"), tp = inp.time.split(":");
var y = +dp[0], m = +dp[1], d = +dp[2], hh = +tp[0], mm = +tp[1];
var utMin = hh * 60 + mm - (inp.tzOffsetMinutes || 0);
var uH = Math.floor(utMin / 60), uM = ((utMin % 60) + 60) % 60;
var uY = y, uMo = m, uD = d;
if (uH < 0) { uH += 24; uD -= 1; if (uD < 1) { uMo -= 1; if (uMo < 1) { uMo = 12; uY -= 1; } uD = new Date(uY, uMo, 0).getDate(); } }
else if (uH >= 24) { uH -= 24; uD += 1; var ml = new Date(uY, uMo, 0).getDate(); if (uD > ml) { uD = 1; uMo += 1; if (uMo > 12) { uMo = 1; uY += 1; } } }
var jd = julianDay(uY, uMo, uD, uH, uM);
var dj = jd - 2451543.5;
var ay = lahiri(jd);
var ascT = ascendantTrop(jd, inp.latitude, inp.longitude);
var ascS = sidereal(ascT, ay);
var ascRashi = Math.floor(ascS / 30);
var bodies = [];
["sun","moon","mars","mercury","jupiter","venus","saturn"].forEach(function(p) {
bodies.push({ k: p, lon: sidereal(geoLon(p, dj), ay), retro: isRetrograde(p, dj) });
});
var rl = sidereal(rahuLon(dj), ay);
bodies.push({ k: "rahu", lon: rl, retro: true });
bodies.push({ k: "ketu", lon: norm360(rl + 180), retro: true });
var planets = bodies.map(function(b) {
var mt = PLANETS.filter(function(p) { return p.k === b.k; })[0];
var rIdx = Math.floor(b.lon / 30);
var seg = 360 / 27, nIdx = Math.floor(b.lon / seg);
var pada = Math.min(4, Math.floor((b.lon - nIdx * seg) / (seg / 4)) + 1);
var relHouse = Math.floor(norm360(b.lon - ascRashi * 30) / 30) + 1;
return {
k: mt.k, en: mt.en, sa: mt.sa, s: mt.s, c: mt.c,
lon: b.lon, rIdx: rIdx, rName: RASHIS[rIdx].en, rSa: RASHIS[rIdx].sa,
house: relHouse, nak: NAKSHATRAS[nIdx].en, nakSa: NAKSHATRAS[nIdx].sa,
pada: pada, retro: b.retro
};
});
var moon = planets.filter(function(p) { return p.k === "moon"; })[0];
var sun = planets.filter(function(p) { return p.k === "sun"; })[0];
var mars = planets.filter(function(p) { return p.k === "mars"; })[0];
var saturn = planets.filter(function(p) { return p.k === "saturn"; })[0];
var rahu = planets.filter(function(p) { return p.k === "rahu"; })[0];
var ketu = planets.filter(function(p) { return p.k === "ketu"; })[0];

var manglikHouses = [1,2,4,7,8,12];
var manglik = { on: manglikHouses.indexOf(mars.house) >= 0 };
manglik.reason = manglik.on ? "Mars is in house " + mars.house + " — classical texts call this Manglik / Mangal dosha. Effect softens after 28 and with remedy." : "Mars is not in a Manglik-triggering house. No Mangal dosha.";
var others = planets.filter(function(p) { return p.k !== "rahu" && p.k !== "ketu"; });
var start = rahu.house, end = ketu.house;
var between = function(p) { if (start < end) return p.house > start && p.house < end; return p.house > start || p.house < end; };
var ksy = others.every(between);
var kaal = { on: ksy, reason: ksy ? "All seven planets fall on one side of the Rahu–Ketu axis — Kaal Sarp Yoga is present." : "Planets fall on both sides of the Rahu–Ketu axis. No Kaal Sarp Yoga." };
var satDiff = Math.abs(saturn.rIdx - moon.rIdx);
var sadeOn = satDiff <= 1 || satDiff === 11;
var sade = { on: sadeOn, reason: sadeOn ? "Saturn is within one sign of your natal Moon (" + moon.rName + "). You are inside the seven-and-a-half-year Sade Sati window — a period of deep restructuring." : "Saturn is more than one sign away from your natal Moon. You are outside Sade Sati." };

var seg2 = 360 / 27;
var moonNakIdx = Math.floor(moon.lon / seg2);
var nakStart = moonNakIdx * seg2;
var nakLord = NAKSHATRAS[moonNakIdx].lord;
var rem = 1 - (moon.lon - nakStart) / seg2;
var yrsRem = DASHA_YEARS[nakLord] * rem;
var birthDate = new Date(inp.date + "T" + inp.time + ":00");
var seq = [];
var cursor = new Date(birthDate.getTime());
var firstEnd = new Date(cursor.getTime() + yrsRem * 365.25 * 24 * 3600 * 1000);
seq.push({ lord: nakLord, from: cursor.toISOString(), to: firstEnd.toISOString(), years: +yrsRem.toFixed(2) });
cursor = firstEnd;
var si = DASHA_ORDER.indexOf(nakLord);
for (var j = 1; j < 12; j++) {
var lord = DASHA_ORDER[(si + j) % DASHA_ORDER.length];
var yy = DASHA_YEARS[lord];
var e2 = new Date(cursor.getTime() + yy * 365.25 * 24 * 3600 * 1000);
seq.push({ lord: lord, from: cursor.toISOString(), to: e2.toISOString(), years: yy });
cursor = e2;
}
seq.forEach(function(d) { d.antardashas = antardashasFor(d.lord, d.from, d.years); });
var now = new Date();
var current = seq.filter(function(d) { return new Date(d.to) > now && new Date(d.from) <= now; })[0] || seq[0];
var currentAntar = current.antardashas.filter(function(a) { return new Date(a.to) > now && new Date(a.from) <= now; })[0] || current.antardashas[0];

var moonRashiKey = RASHIS[moon.rIdx].key;
var ascRashiKey = RASHIS[ascRashi].key;

var pan = panchang(sun.lon, moon.lon);
var vara = VARA_NAMES[new Date(inp.date + "T12:00:00").getDay()];
var ss = sunriseSunset(uY, uMo, uD, inp.latitude, inp.longitude, inp.tzOffsetMinutes);

var avakhada = {
varna: VARNA[moonRashiKey],
vashya: VASHYA[moonRashiKey],
yoni: YONIS[moonNakIdx],
gan: GANS[moonNakIdx],
nadi: NADIS[moonNakIdx],
tatva: TATVA_BY_RASHI[moonRashiKey],
paya: PAYA_BY_RASHI[moonRashiKey],
alphabet: NAK_ALPHABETS[moonNakIdx][moon.pada - 1],
signLord: RASHIS[moon.rIdx].lord,
charan: moon.pada,
nakshatraLord: NAKSHATRAS[moonNakIdx].lord
};

return {
input: inp,
ayanamsa: ay,
ascendant: { rIdx: ascRashi, en: RASHIS[ascRashi].en, sa: RASHIS[ascRashi].sa, lord: RASHIS[ascRashi].lord, el: RASHIS[ascRashi].el },
moon: { rIdx: moon.rIdx, en: RASHIS[moon.rIdx].en, sa: RASHIS[moon.rIdx].sa, nak: moon.nak, nakSa: moon.nakSa, pada: moon.pada, lord: NAKSHATRAS[moonNakIdx].lord },
sun: { rIdx: sun.rIdx, en: RASHIS[sun.rIdx].en, sa: RASHIS[sun.rIdx].sa },
planets: planets,
doshas: { manglik: manglik, kaal: kaal, sade: sade },
dashas: { current: current, currentAntar: currentAntar, sequence: seq },
traits: TRAITS[ascRashiKey],
horoscope: dailyHoro(moonRashiKey, now),
recs: RECS[moonRashiKey] || RECS[ascRashiKey],
panchang: { tithi: pan.tithi, paksha: pan.paksha, karana: pan.karana, yoga: pan.yoga, vara: vara, sunrise: ss.rise, sunset: ss.set },
avakhada: avakhada
};
}
function fmtDeg(x) {
var i = x % 30, deg = Math.floor(i), min = Math.floor((i - deg) * 60);
return deg + "° " + (min < 10 ? "0" : "") + min + "'";
}
SK.computeKundli = computeKundli; SK.fmtDeg = fmtDeg;
})(window.SK = window.SK || {});
